import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ziyuanldpi",
  "use": "icon-ziyuanldpi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ziyuanldpi\"><path d=\"M94.408039 491.009382a73.112568 73.112568 0 0 0 103.819846 0L438.768233 249.737909V950.887432a73.112568 73.112568 0 0 0 146.225135 0V249.737909l240.540347 241.271473a73.112568 73.112568 0 0 0 103.819846-103.819846l-365.562838-365.562838a73.112568 73.112568 0 0 0-103.819846 0l-365.562838 365.562838a73.112568 73.112568 0 0 0 0 103.819846z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol